const currencies = [
  {
    name: "Kuwaiti Dinar",
    id: "kwd",
  },

  {
    name: "Bahraini Dinar",
    id: "bhd",
  },

  {
    name: "British Pound",
    id: "gbp",
  },

  {
    name: "European Euro",
    id: "eur",
  },

  {
    name: "Swiss Franc",
    id: "chf",
  },

  {
    name: "US Dollar",
    id: "usd",
  },

  {
    name: "Bermudian Dollar",
    id: "bmd",
  },

  {
    name: "Canadian Dollar",
    id: "cad",
  },

  {
    name: "Australian Dollar",
    id: "aud",
  },

  {
    name: "Singapore Dollar",
    id: "sgd",
  },

  {
    name: "New Zealand Dollar",
    id: "nzd",
  },

  {
    name: "Brazil Real",
    id: "brl",
  },

  {
    name: "Japanese Yen",
    id: "jpy",
  },

  {
    name: "Renminbi",
    id: "cny",
  },

  {
    name: "Hong Kong dollar",
    id: "hkd",
  },

  {
    name: "Swedish Krona",
    id: "sek",
  },

  {
    name: "South Korean won",
    id: "krw",
  },

  {
    name: "Norwegian Krone",
    id: "nok",
  },

  {
    name: "Mexican Peso",
    id: "mxn",
  },

  {
    name: "Indian Rupee",
    id: "inr",
  },

  {
    name: "Russian Ruble",
    id: "rub",
  },

  {
    name: "South African Rand",
    id: "zar",
  },

  {
    name: "Turkish Lira",
    id: "try",
  },

  {
    name: "New Taiwan Dollar",
    id: "twd",
  },

  {
    name: "Danish Krone",
    id: "dkk",
  },

  {
    name: "Polish Złoty",
    id: "pln",
  },

  {
    name: "Thai Baht",
    id: "thb",
  },

  {
    name: "Indonesian Rupiah",
    id: "idr",
  },

  {
    name: "Hungarian Forint",
    id: "huf",
  },

  {
    name: "Czech Koruna",
    id: "czk",
  },

  {
    name: "Israeli New Shekel",
    id: "ils",
  },

  {
    name: "Chilean Peso",
    id: "clp",
  },

  {
    name: "Philippine Peso",
    id: "php",
  },

  {
    name: "UAE Dirham",
    id: "aed",
  },

  {
    name: "Saudi Arabian Riyal",
    id: "sar",
  },

  {
    name: "Malaysian Ringgit",
    id: "myr",
  },
];

module.exports = currencies;
